import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthViewComponent } from './auth-view/auth-view.component';
import { LoginMailComponent } from './login-mail/login-mail.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MyCustomMaterialModule } from 'san-common';



@NgModule({
  declarations: [AuthViewComponent,
    LoginMailComponent],exports:[
      AuthViewComponent,
      LoginMailComponent],
  imports: [
    CommonModule,
    MyCustomMaterialModule,
    RouterModule,ReactiveFormsModule
  ]
})
export class AuthSharedModule { }
